import Popover from "bootstrap/js/dist/popover";

let isMobile =
  "ontouchstart" in window ||
  navigator.MaxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0;

var popoverTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="popover"]')
);

popoverTriggerList.forEach(function (hotspotElement) {
  let content = hotspotElement.querySelector('[data-name="popover-content"]');
  let popover = new Popover(hotspotElement, {
    trigger: isMobile ? "click" : "manual",
    animation: false,
    html: true,
    content: content,
    customClass: "hotspot-popover",
  });

  if (!isMobile) {
    let onHotspot = false;
    let onPopover = false;
    let isPopoverShown = false;
    let hideTimeout;

    const hidePopover = (timeout) => {
      hideTimeout = setTimeout(() => {
        if (onPopover || onHotspot) return;
        popover.hide();
        isPopoverShown = false;
      }, timeout);
    };

    hotspotElement.addEventListener("mouseover", () => {
      onHotspot = true;
      if (!isPopoverShown) {
        popover.show();
        isPopoverShown = true;
      }
      clearTimeout(hideTimeout);
    });

    content.addEventListener("mouseover", () => {
      onPopover = true;
      clearTimeout(hideTimeout);
    });

    hotspotElement.addEventListener("mouseout", () => {
      onHotspot = false;
      hidePopover(100); // add a delay of 100ms before hiding the popover
    });

    content.addEventListener("mouseout", () => {
      onPopover = false;
      hidePopover(100); // add a delay of 100ms before hiding the popover
    });
  }
});
